'use strict';

// 日別ページの日付フィルターで、選択中の日付チップを横スクロールの左端に表示する。
// scrollIntoView はドキュメント全体を縦スクロールさせ、遷移時の上部スクロールを
// 打ち消してしまうため、横スクロールコンテナの scrollLeft だけを操作する。
// offsetLeft は offsetParent（body など）基準でサイドバー幅や余白を含んでしまうため、
// フィルターとチップの表示位置の差から求める。
$(document).on('turbolinks:load', function() {
  const filter = document.querySelector('.daily-stats-filter');
  if (!filter) {
    return;
  }

  const activeChip = filter.querySelector('.js-active-date');
  if (!activeChip) {
    return;
  }

  const alignActiveChipToLeft = function() {
    const offset = activeChip.getBoundingClientRect().left - filter.getBoundingClientRect().left;
    filter.scrollLeft += offset;
  };

  alignActiveChipToLeft();
  // Webフォントの読み込みでチップ幅が変わると位置がずれるため、読み込み完了後にも揃え直す
  if (document.fonts) {
    document.fonts.ready.then(alignActiveChipToLeft);
  }
});
